import(/* webpackMode: "eager" */ "/vercel/path0/app/(info)/privacy/page.tsx");
